export const state = {
    enabled: null,
    pinUrl: null,
    username: null,
    accessToken: null,
    timeout: null,
    defaultIndexer: null,
    sync: null,
    syncRemove: null,
    syncWatchlist: null,
    methodAdd: null,
    removeWatchlist: null,
    removeSerieslist: null,
    removeShowFromApplication: null,
    startPaused: null,
    blacklistName: null
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
